import { render, staticRenderFns } from "./EditQuestionnairesComponent.vue?vue&type=template&id=8ec24c2a&"
import script from "./EditQuestionnairesComponent.vue?vue&type=script&lang=js&"
export * from "./EditQuestionnairesComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestionnairesComponent.vue?vue&type=style&index=0&id=8ec24c2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports